import { render, staticRenderFns } from "./adddraftactivityform.vue?vue&type=template&id=580a9862&scoped=true&"
import script from "./adddraftactivityform.vue?vue&type=script&lang=js&"
export * from "./adddraftactivityform.vue?vue&type=script&lang=js&"
import style0 from "./adddraftactivityform.vue?vue&type=style&index=0&id=580a9862&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580a9862",
  null
  
)

export default component.exports